<p-tabs value="feasibility">
    <p-tablist>
        <p-tab value="feasibility">{{ 'ADMINISTRATION.FEASIBILITY_RULES' | translate }}</p-tab>
    </p-tablist>
    <p-tabpanels>
        <p-tabpanel value="feasibility">
            <app-admin-feasibility></app-admin-feasibility>
        </p-tabpanel>
    </p-tabpanels>
</p-tabs>